import { render, staticRenderFns } from "./Brintellix.vue?vue&type=template&id=eefd6a42&scoped=true"
import script from "./Brintellix.vue?vue&type=script&lang=js"
export * from "./Brintellix.vue?vue&type=script&lang=js"
import style0 from "./Brintellix.vue?vue&type=style&index=0&id=eefd6a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefd6a42",
  null
  
)

export default component.exports